export const VERSION = '4.93.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map